import { type AdsAttribution, parseAdsAttribution } from "@teksta/shared-types";

export function paidTouchFromUrl(search: string, now = Date.now()): AdsAttribution | undefined {
  const params = new URLSearchParams(search);
  const source = params.get("utm_source");
  const medium = params.get("utm_medium");
  // Internal links use landing/main_cta. They must never become a new paid touch.
  const chatgpt = source === "chatgpt_ads" || params.has("oppref");
  const paid =
    chatgpt ||
    params.has("gclid") ||
    params.has("gbraid") ||
    params.has("wbraid") ||
    params.has("msclkid") ||
    /^(cpc|ppc|paid|paid_social)$/i.test(medium ?? "");
  if (!paid || source === "landing") return;
  return parseAdsAttribution(
    {
      ads_source:
        source ||
        (chatgpt
          ? "chatgpt_ads"
          : params.has("gclid") || params.has("gbraid") || params.has("wbraid")
            ? "google"
            : params.has("msclkid")
              ? "bing"
              : "unknown"),
      ads_captured_at: String(now),
      ...(params.get("utm_campaign") || params.get("utm_kamp")
        ? { ads_campaign: params.get("utm_campaign") || params.get("utm_kamp") }
        : {}),
      ...(medium ? { ads_medium: medium } : {}),
      ...(params.get("ad_id") ? { ads_ad_id: params.get("ad_id") } : {}),
      ...(params.get("oppref") ? { ads_oppref: params.get("oppref") } : {}),
    },
    now
  );
}
